<template>
	<div class="page-container">
		<e-nav :type="0"></e-nav>
        <div v-for="(section, title) in listData" :key="title" class="list-section">
            <div class="list-section-title">{{title}}</div>
            <div class="list-container">
                <div v-for="(item, index) in section" :key="index" class="list-cell">
                    <div v-lazy-container="{selector: 'img'}" :class="item['是否获奖'] ? 'cup' : '' ">
                        <div class="img"><img :data-src="item['url'] ? item['url'] : defUrl" :data-error="defUrl" class="list-img"/></div>
                        <div class="list-info">
                            <template v-for="(val, key) in item">
                                <span :key="key"  v-if="key == '作品名称'" class="name">{{val}}</span>
                                <span :key="key"  v-else-if="key != 'url' && key != '是否获奖' ">{{key}}：{{val}}</span>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
	</div>
</template>

<script>
import eNav from '@/components/Nav'
import listData2017 from '@/mock/cma2017'
import listData2018 from '@/mock/cma2018'

export default {
	name: 'cma_old',
	components: {
		eNav
	},
	data () { 
		return {
            listGroup:{
                2017:listData2017,
                2018:listData2018
            },
            listData: [],
            defUrl: 'http://img01.cmicawards.org.cn/cover/CMADefault.jpg'
		}
	},
	mounted: function() {
        this.listData = this.listGroup[this.$route.params.id];
    },
	methods:{}
}
</script>
<style lang="scss" scoped>
	.list-section {
		padding: 20px 0;

		.list-section-title {
			font-size: 24px;
            color: #181413;
			line-height: 24px;
		}

		.list-container {
            margin-top: 10px;
            overflow: hidden;

            .list-cell {
                float: left;
                margin-top: 20px;
                width: 50%;

                &> div{
                    margin-right: 20px;
                    overflow: hidden;
                    background-color: #FBFCFE;
                    position: relative;
                    &.cup{
                        background:url('../assets/images/cup_1.png')  #FBFCFE 96% 10% no-repeat;
                    }
                    .img{
                        /*弹性盒模型*/    
                        display:flex;
                        /*主轴居中对齐*/
                        justify-content: center;
                        /*侧轴居中对齐*/    
                        align-items: center; 
                        width: 250px;
                        height: 250px;
                        float: left;
                        text-align: center;
                        background-color: #000;
                        .list-img {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    }
                    .list-info {
                        margin: 0 20px 0 270px;
                        padding: 15px 0;
                        overflow: hidden;

                        span {
                            display: block;
                            font-size: 12px;
                            color: #AAAAAA;
                            line-height: 24px;
                            // overflow: hidden;
                            // text-overflow: ellipsis;
                            // white-space: nowrap;

                            &.name {
                                padding-bottom: 15px;
                                font-size: 24px;
                                color: #AF804D;
                                line-height: 28px;
                                overflow: visible;
                                text-overflow: ellipsis;
                                white-space: normal;
                            }
                        }
                    } 

                }

            }
		}
	}
</style>

